import React, { FC } from 'react';
import ShareIcon from '@mui/icons-material/Share';

import { buttonVariants, buttonWidths } from '@clatter/ui';
import { NgButton } from '..';

interface NgShareButtonProps {
  dsiabled?: boolean;
  onClick: () => void;
}

export const NgShareButton: FC<NgShareButtonProps> = ({ dsiabled, onClick }) => {
  return (
    <NgButton
      width={buttonWidths.sm}
      variant={buttonVariants.clear}
      onClick={onClick}
      disabled={dsiabled}
      icon={ShareIcon}
    >
      Share
    </NgButton>
  );
};
